import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BibBrief from '@bibliocommons/shared-bib-brief';
import { getIconForFormat } from '@bibliocommons/utils-format';
import { ugcSimilarTitlesShape, bibShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import FormatInfoContainer from '../../../../containers/FormatInfoContainer';
import JacketCoverContainer from '../../../../containers/JacketCoverContainer';

import DisplayWrapper from '../DisplayWrapper';
import DisplayActions from '../DisplayActions';

import './SimilarTitleDisplay.scss';

export default class SimilarTitleDisplay extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      showEditor: false
    };

    this.bindAll('renderBibBrief');
  }

  renderActions(briefInfo) {
    const { similarTitlesActions, similarTitlesTransactions, similarTitle, owner } = this.props;

    if (owner.get('loggedIn')) {
      const similarTitleId = similarTitle.get('id');
      const metadataId = similarTitle.get('metadataId');
      const title = briefInfo.get('title');
      const handleRemove = () => similarTitlesActions.removeSimilarTitle(metadataId, similarTitleId);
      const isRemoving = similarTitlesTransactions.getIn([metadataId, similarTitleId, 'isRemoving'], false);
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_similar_title" values={{ title }} />;

      return (
        <DisplayActions
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          removeScreenReaderMessage={removeScreenReaderMessage} />
      );
    }

    return null;
  }

  renderBibBrief(similarTitleBib) {
    const briefInfo = similarTitleBib.get('briefInfo');

    return (
      <div className="similar-titles-bib-brief-info">
        <BibBrief bib={briefInfo} renderTitleAsLink={!!briefInfo.get('id')} titleTag="h5" truncateTitleOptions={{ desiredLength: 50 }}>
          <div className="similar-titles-item-format">
            <span className={getIconForFormat(briefInfo.get('format'))} aria-hidden />
            <FormatInfoContainer item={similarTitleBib} showCallNumber={false} />
          </div>
        </BibBrief>
        {this.renderActions(briefInfo)}
      </div>
    );
  }

  render() {
    const briefInfo = this.props.similarTitleBib.get('briefInfo');

    return (
      <DisplayWrapper className="cp-ugc-similar-title-display">
        <div className="jacket-cover-container">
          <JacketCoverContainer src={briefInfo.get('jacket')} format={briefInfo.get('format')} alt="" />
        </div>
        {this.renderBibBrief(this.props.similarTitleBib)}
      </DisplayWrapper>
    );
  }
}

SimilarTitleDisplay.propTypes = {
  similarTitleBib: bibShape.isRequired,
  similarTitle: ugcSimilarTitlesShape.isRequired,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  owner: userIdentityShape.isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/UGC/SimilarTitleDisplay/SimilarTitleDisplay.jsx